import React from 'react';
import './FinalizationBanner.css';

interface FinalizationBannerProps {
  visible: boolean;
}

const FinalizationBanner: React.FC<FinalizationBannerProps> = ({ visible }) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="finalization-banner">
      <div className="finalization-spinner"></div>
      <div className="finalization-text">
        <strong>Processing your criteria...</strong>
        <span className="finalization-subtext">(30-60 seconds)</span>
      </div>
    </div>
  );
};

export default FinalizationBanner;
